import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getUserById } from "../../../../redux/userSlice/userSlice";
import Swal from "sweetalert2";
import { deleteMainTenanceSchedule, getAllMaintenanceSchedule } from "../../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import { AuthContext } from "../../../../context/AuthContext";
import { ROLES } from "../../../../constants/roles";

export default function MaintenanceSchedulesCard({ maintenanceSchedule }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { detailsUser } = useSelector((state) => state.user);
  const { role } = useContext(AuthContext);

  const isMaintenanceItemPage = location.pathname.match(/\/MaintenanceItem\/\d+$/);
  const isTasksPage = location.pathname == "/Tasks";

  useEffect(() => {
    if (maintenanceSchedule?.maintenance_manager_id) {
      dispatch(getUserById(maintenanceSchedule.maintenance_manager_id));
    }
  }, [dispatch, maintenanceSchedule?.maintenance_manager_id]);

  const handleDelete = async (scheduleId) => {
    console.log("scheduleId", scheduleId);
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من استرجاع جدول الصيانة بعد الحذف!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      try {
        const deleteAction = await dispatch(deleteMainTenanceSchedule(scheduleId)).unwrap();
        await dispatch(getAllMaintenanceSchedule());
        if (deleteAction) {
          Swal.fire("تم الحذف!", "تم حذف جدول الصيانة بنجاح.", "success");
        }
      } catch (error) {
        Swal.fire("خطأ!", "حدث خطأ أثناء حذف جدول الصيانة، حاول مرة أخرى.", "error");
        console.error("Error deleting maintenance schedule:", error);
      }
    }
  };

  return (
    <div className="maintenance-item-card card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="mt-2 fs-4">
          جدول صيانة دورية لشركة {maintenanceSchedule?.contractSchedule?.branch?.company?.name} فرع {maintenanceSchedule?.contractSchedule?.branch?.name}
        </h3>
        <div className="rounded-circle bg-100 accent-200">
          <i className="fa-solid fa-bolt"></i>
        </div>
      </div>
      <div className="maintenance-item-info card-body">
        <div className="row align-items-center">
          <p className="col-5"> الاسم </p>
          <p className="col-1">:</p>
          <p className="col-5">{maintenanceSchedule?.title}</p>
        </div>
        <div className="row align-items-center">
          <p className="col-5">الأولوية</p>
          <p className="col-1">:</p>
          <p className="col-5">{maintenanceSchedule?.priority}</p>
        </div>
        <div className="row align-items-center">
          <p className="col-5">المسئول عن الجدول</p>
          <p className="col-1">:</p>
          <p className="col-5">{detailsUser?.name || "لم يتم تحديد المسئول بعد"}</p>
        </div>
        <div className="row align-items-center">
          <p className="col-5">التاريخ</p>
          <p className="col-1">:</p>
          <p className="col-5 ">{maintenanceSchedule?.schedule_date || ""}</p>
        </div>

        {!isMaintenanceItemPage && (
          <div className="d-flex align-items-center flex-wrap justify-content-center gap-4 ">
            {/* <Link className="btn btn-primary text-white" to={`/ShowMoreMaintenanceSchedule/${maintenanceSchedule?.id}`}>
              مشاهدة التفاصيل
            </Link> */}
            {!isTasksPage && (
              <>
                <Link className="btn btn-primary text-white" to={`/AddMaintenanceSchedule/${maintenanceSchedule?.id}`}>
                  إضافة
                </Link>
                <Link className="btn btn-warning text-white" to={`/ShowMoreMaintenanceSchedule/${maintenanceSchedule?.id}`}>
                  تعديل
                </Link>
                <Link className="btn btn-info text-white" to={`/MaintenanceSchedules/addMangerAndStuff/${maintenanceSchedule?.id}`}>
                  توكيل
                </Link>
              </>
            )}
            {maintenanceSchedule?.assigned_to !== null && (
              <Link className="btn btn-success text-white" to={`/MaintenanceSchedules/${maintenanceSchedule?.id}/updateMaintenanceItem`}>
                بدأ الصيانة
              </Link>
            )}
            {maintenanceSchedule?.assigned_to !== null && (
              <Link className="btn btn-secondary text-white" to={`/MaintenanceSchedules/${maintenanceSchedule?.id}/statusMaintenanceItem`}>
                تقرير الصيانة
              </Link>
            )}
            {((role == ROLES.MANAGER && !isTasksPage) || (role == ROLES.OWNER && !isTasksPage)) && (
              <button className="btn btn-danger text-white" onClick={() => handleDelete(maintenanceSchedule?.id)}>
                حذف
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
